export var BASE_URL = "http://tgtgsw.appcloudbox.net";
export var API_KEY = "PfjuEIOoInZZXvyVVakrSinMe";
export var SECRET_KEY = "U8Mi&7NK~3Y)Q3&;`8o<k%[)AI)NQS9N";
export var UA = "PalmistryPro/12 CFNetwork/976 Darwin/18.2.0";
export var QUERY_BABY = "/api/face/baby";